module.exports = __webpack_public_path__ + "static/media/about1.beba64a3.jpg";